
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2645_138)","fill":"#43B4EB"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.1.5a3.667 3.667 0 00-3.667 3.667v.42c0 .656.195 1.268.531 1.78H2.7a2.2 2.2 0 00-2.2 2.2v1.466a2.2 2.2 0 002.2 2.2h8.067V6.367h1.466v5.866H20.3a2.2 2.2 0 002.2-2.2V8.567a2.2 2.2 0 00-2.2-2.2h-1.264a3.234 3.234 0 00.53-1.78v-.42A3.666 3.666 0 0015.9.5a5.131 5.131 0 00-4.4 2.487A5.13 5.13 0 007.1.5zm5.133 5.867h4.087c.982 0 1.78-.798 1.78-1.78v-.42a2.2 2.2 0 00-2.2-2.2 3.666 3.666 0 00-3.667 3.666v.734zm-1.466 0H6.68c-.983 0-1.781-.798-1.781-1.78v-.42a2.2 2.2 0 012.2-2.2 3.667 3.667 0 013.667 3.666v.734z"}}),_c('path',{attrs:{"d":"M10.767 13.7h-8.8v5.133A3.667 3.667 0 005.633 22.5h5.134v-8.8zm1.466 8.8h5.134a3.667 3.667 0 003.666-3.667V13.7h-8.8v8.8z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2645_138"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    